export default __webpack_public_path__ + "static/CEO-BLOG-SERIES-5e63018c6cad3deed575d736bb841b32.jpeg";